module.exports = __webpack_public_path__ + "static/media/logout.f6805135.svg";